require('./stylesheet/style.scss');

angular.module('navigation.frameNavBottom', [])
	.directive('frameNavBottom', [function() {
		return {
			template: require('./templates/index.html'),
			controller: ['$scope', function($scope) {
				$scope.currentYear = new Date().getFullYear();
			}],
			link: function($scope, Pay) {
				$scope.pay = Pay;
            }
		}
	}

]);

module.exports = 'navigation.frameNavBottom';



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameFooter/index.js
 ** module id = 247
 ** module chunks = 1
 **/